export default from './registry-sidenav-container'
